import { render, staticRenderFns } from "./DictionaryEditor.vue?vue&type=template&id=0a92daac"
import script from "./DictionaryEditor.vue?vue&type=script&lang=js"
export * from "./DictionaryEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports